import CRMListings from './crmListings';
import ActivitiesListings from './activitiesListings';
import SalesListings from './salesListings';
import OcrListing from './ocrListing';
import Groups from './groups';
import AccountingListing from './accountingListing';

import DefaultListingConfig from './defaultListingConfig';

class ListingConfig {
    constructor() {
        this.groups = Groups;
        this.listings = [];
        this.feedListings();
    }

    /**
     * Merge each listing with template
     *
     */
    feedListings() {
        CRMListings.forEach((listing) => {
            this.listings.push({ ...DefaultListingConfig, ...listing });
        });
        ActivitiesListings.forEach((listing) => {
            this.listings.push({ ...DefaultListingConfig, ...listing });
        });
        SalesListings.forEach((listing) => {
            this.listings.push({ ...DefaultListingConfig, ...listing });
        });
        OcrListing.map((listing) => {
            this.listings.push({ ...DefaultListingConfig, ...listing });
        }),
        AccountingListing.map((listing) => {
            this.listings.push({ ...DefaultListingConfig, ...listing });
        });
    }

    /**
     * Return all listings
     * @returns {Array}
     */
    getListings() {
        return this.listings;
    }

    /**
     * Return one listing find by key
     * @param String key
     * @returns {Object}
     */
    getListing(key = '') {
        if (key != '') {
            return this.listings.find((listing) => listing.id == key);
        }
        throw new Error('Key is required');
    }

    /**
     * Return one listing find by name
     * @param String name
     * @returns {Object}
     */
    getListingByName(name = '') {
        if (name != '') {
            return this.listings.find((listing) => listing.name == name);
        }
        throw new Error('Name is required');
    }

    /**
     * Return listing matched with keys
     * @param Array keys
     * @returns {Array}
     */
    getListingsByKeys(keys = []) {
        if (keys && keys.length > 0) {
            return this.listings.map((listing) => {
                return keys.includes(listing.key);
            });
        }
        throw new Error('Keys is required and keys contain at least 1 element');
    }

    /**
     * Return light data of listings in the group (with route & label of the group)
     * @param String
     * @returns {Object}
     */
    getGroup(group = '') {
        if (group != '' && this.groups[group]) {
            return this.groups[group];
        }
        throw new Error('Group is required');
    }

    /**
     * Return all listings of one group
     * @param String group
     * @returns {Array}
     */
    getListingsByGroup(group = '') {
        if (group != '') {
            return this.listings.filter((listing) => listing.group == group);
        }
        throw new Error('Group is required');
    }

    /**
     * Return listings after check permissions
     * @param String route
     * @param Array listings
     * @returns {Array}
     */
    async checkPermissionsListingGroup(route, listings) {
        const listingsAvailable = [];
        const response = await this.getPermissionsListings(route);

        for (const listing of listings) {
            if (response[listing.permission] || _.isNil(listing.permission)) {
                listingsAvailable.push(listing);
            }
        }

        return listingsAvailable;
    }

    /**
     * Promise to check Permissions
     * @param String route
     * @returns {Promise}
     */
    getPermissionsListings(route) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(route, {}, (response) => {
                resolve(response);
            });
        });
    }
}

export default ListingConfig;
